export default "__VITE_ASSET__CfLqFYHT__"